// src/components/mariniProductsData.js

const mariniProductsData = [
    {
        id: 1,
        name: "Skin Care Management System - Normal SPF 33",
        category: "MariniProducts",
        logo: require("../assets/images/allproducts/logos/MSS-Logo-lockup1-color.png"),
        mainImage: require("../assets/images/allproducts/MariniProducts/marini.png"),
        images: [
            require("../assets/images/allproducts/MariniProducts/marini.png"),
            require("../assets/images/allproducts/MariniProducts/marini2.jpg"),
            require("../assets/images/allproducts/MariniProducts/marini3.jpg")
        ],
        subHeading: "Complete daily protection with SPF 33",
        overview: "A daily skincare system for normal skin, offering hydration and sun protection with SPF 33.",
        breadcrumbImage: require("../assets/images/skin-breadcrum.jpg"),
        howToUse: {
            thumb: require("../assets/images/skin-breadcrum.jpg"),
            video: require("../assets/Video/0_Molecular_Cosmetics_1920x1080 (1).mp4")
        },
        benefits: ["Hydrates skin", "Protects from UV", "Maintains balance"],
        application: ["Apply in the morning to clean skin.", "Spread evenly on face and neck.", "Reapply every 2 hours in the sun."]
    },

    {
        id: 2,
        name: "Skin Care Management System - Normal SPF 45",
        category: "MariniProducts",
        logo: require("../assets/images/allproducts/logos/MSS-Logo-lockup1-color.png"),
        mainImage: require("../assets/images/allproducts/MariniProducts/marini2.jpg"),
        images: [
            require("../assets/images/allproducts/MariniProducts/marini2.jpg"),
            require("../assets/images/allproducts/MariniProducts/marini.png"),
            require("../assets/images/allproducts/MariniProducts/marini3.jpg")
        ],
        subHeading: "High SPF protection for normal skin",
        overview: "A daily skincare system for normal skin with extra sun protection SPF 45, keeping your skin safe and hydrated.",
        breadcrumbImage: require("../assets/images/skin-breadcrum.jpg"),
        howToUse: {
            thumb: require("../assets/images/skin-breadcrum.jpg"),
            video: require("../assets/Video/0_Molecular_Cosmetics_1920x1080 (1).mp4")
        },
        benefits: ["Maximum sun protection", "Moisturizes", "Prevents sun damage"],
        application: ["Apply in the morning after cleansing.", "Cover entire face and neck.", "Reapply after sweating or swimming."]
    },

    {
        id: 3,
        name: "Skin Care Management System - Very Dry SPF 33",
        category: "MariniProducts",
        logo: require("../assets/images/allproducts/logos/MSS-Logo-lockup1-color.png"),
        mainImage: require("../assets/images/allproducts/MariniProducts/marini3.jpg"),
        images: [
            require("../assets/images/allproducts/MariniProducts/marini3.jpg"),
            require("../assets/images/allproducts/MariniProducts/marini2.jpg"),
            require("../assets/images/allproducts/MariniProducts/marini.png")
        ],
        subHeading: "Hydration-focused system for very dry skin",
        overview: "Specialized for very dry skin, this system hydrates deeply while offering SPF 33 sun protection.",
        breadcrumbImage: require("../assets/images/skin-breadcrum.jpg"),
        howToUse: {
            thumb: require("../assets/images/skin-breadcrum.jpg"),
            video: require("../assets/Video/0_Molecular_Cosmetics_1920x1080 (1).mp4")
        },
        benefits: ["Deep hydration", "UV protection", "Nourishes skin"],
        application: ["Apply generously to dry areas.", "Use morning and evening.", "Reapply SPF during daytime."]
    },

    {
        id: 4,
        name: "Starter Skin Care Management System",
        category: "MariniProducts",
        logo: require("../assets/images/allproducts/logos/MSS-Logo-lockup1-color.png"),
        mainImage: require("../assets/images/allproducts/MariniProducts/scms_starter_angle.jpg"),
        images: [
            require("../assets/images/allproducts/MariniProducts/scms_starter_angle.jpg"),
            require("../assets/images/allproducts/MariniProducts/scms_starter_angle2.jpg"),
            require("../assets/images/allproducts/MariniProducts/marini3.jpg")
        ],
        subHeading: "Beginner-friendly skincare system",
        overview: "A simple starter kit to introduce your skin to a complete daily care routine.",
        breadcrumbImage: require("../assets/images/skin-breadcrum.jpg"),
        howToUse: {
            thumb: require("../assets/images/skin-breadcrum.jpg"),
            video: require("../assets/Video/0_Molecular_Cosmetics_1920x1080 (1).mp4")
        },
        benefits: ["Easy to use", "Hydrates", "Prepares skin for advanced care"],
        application: ["Follow the included routine steps.", "Use morning and evening.", "Gradually increase usage as needed."]
    },

    {
        id: 5,
        name: "Bioglycolic Face Cleanser",
        category: "MariniProducts",
        logo: require("../assets/images/allproducts/logos/MSS-Logo-lockup1-color.png"),
        mainImage: require("../assets/images/allproducts/MariniProducts/bioglycolicFaceCleanserMain.jpg"),
        images: [
            require("../assets/images/allproducts/MariniProducts/bioglycolicFaceCleanserMain.jpg"),
            require("../assets/images/allproducts/MariniProducts/bioglycolicFaceCleanserThumb1.jpg"),
            require("../assets/images/allproducts/MariniProducts/bioglycolicFaceCleanserThumb2.jpg")
        ],
        subHeading: "Gentle glycolic exfoliating cleanser",
        overview: "Effectively removes impurities and promotes smooth, radiant skin using gentle glycolic acids.",
        breadcrumbImage: require("../assets/images/skin-breadcrum.jpg"),
        howToUse: {
            thumb: require("../assets/images/skin-breadcrum.jpg"),
            video: require("../assets/Video/0_Molecular_Cosmetics_1920x1080 (1).mp4")
        },
        benefits: ["Exfoliates skin", "Removes dirt & oil", "Brightens complexion"],
        application: ["Apply to damp face.", "Massage gently.", "Rinse thoroughly."]
    },

    {
        id: 6,
        name: "C-ESTA Cleasing Gel",
        category: "MariniProducts",
        logo: require("../assets/images/allproducts/logos/MSS-Logo-lockup1-color.png"),
        mainImage: require("../assets/images/allproducts/MariniProducts/cEstaCleansingGelMain.jpg"),
        images: [
            require("../assets/images/allproducts/MariniProducts/cEstaCleansingGelMain.jpg"),
            require("../assets/images/allproducts/MariniProducts/cEstaCleansingGelThumb1.jpg"),
            require("../assets/images/allproducts/MariniProducts/cEstaCleansingGelThumb2.jpg")
        ],
        subHeading: "Vitamin C infused cleansing gel",
        overview: "Brightens skin while gently removing impurities with antioxidant-rich C-ESTA formula.",
        breadcrumbImage: require("../assets/images/skin-breadcrum.jpg"),
        howToUse: { thumb: require("../assets/images/skin-breadcrum.jpg"), video: require("../assets/Video/0_Molecular_Cosmetics_1920x1080 (1).mp4") },
        benefits: ["Brightens skin", "Removes dirt", "Antioxidant protection"],
        application: ["Massage onto damp skin.", "Rinse thoroughly.", "Use daily for best results."]
    },

    {
        id: 7,
        name: "C-Esta Face Serum",
        category: "MariniProducts",
        logo: require("../assets/images/allproducts/logos/MSS-Logo-lockup1-color.png"),
        mainImage: require("../assets/images/allproducts/MariniProducts/cEstaFaceSerumMain.jpg"),
        images: [
            require("../assets/images/allproducts/MariniProducts/cEstaFaceSerumMain.jpg"),
            require("../assets/images/allproducts/MariniProducts/cEstaFaceSerumThumb1.jpg"),
            require("../assets/images/allproducts/MariniProducts/cEstaFaceSerumThumb2.jpg")
        ],
        subHeading: "Concentrated vitamin C serum",
        overview: "Helps reduce fine lines, brighten skin, and improve overall texture using potent C-ESTA formulation.",
        breadcrumbImage: require("../assets/images/skin-breadcrum.jpg"),
        howToUse: { thumb: require("../assets/images/skin-breadcrum.jpg"), video: require("../assets/Video/0_Molecular_Cosmetics_1920x1080 (1).mp4") },
        benefits: ["Reduces wrinkles", "Brightens complexion", "Improves texture"],
        application: ["Apply 2-3 drops to clean skin.", "Massage gently.", "Use daily morning and night."]
    },

    {
        id: 8,
        name: "Bioclear Face Lotion",
        category: "MariniProducts",
        logo: require("../assets/images/allproducts/logos/MSS-Logo-lockup1-color.png"),
        mainImage: require("../assets/images/allproducts/MariniProducts/bioclearFaceLotionMain.jpg"),
        images: [
            require("../assets/images/allproducts/MariniProducts/bioclearFaceLotionMain.jpg"),
            require("../assets/images/allproducts/MariniProducts/bioclearFaceLotionThumb1.jpg"),
            require("../assets/images/allproducts/MariniProducts/bioclearFaceLotionThumb2.jpg")
        ],
        subHeading: "Lightweight lotion for clear skin",
        overview: "Balances and hydrates skin while controlling excess oil and promoting a clear complexion.",
        breadcrumbImage: require("../assets/images/skin-breadcrum.jpg"),
        howToUse: { thumb: require("../assets/images/skin-breadcrum.jpg"), video: require("../assets/Video/0_Molecular_Cosmetics_1920x1080 (1).mp4") },
        benefits: ["Hydrates", "Controls oil", "Promotes clarity"],
        application: ["Apply morning and night to clean skin.", "Massage gently.", "Follow with SPF during the day."]
    },

    {
        id: 9,
        name: "Transformation Face Cream",
        category: "MariniProducts",
        logo: require("../assets/images/allproducts/logos/MSS-Logo-lockup1-color.png"),
        mainImage: require("../assets/images/allproducts/MariniProducts/transformationFaceCreamMain.jpg"),
        images: [
            require("../assets/images/allproducts/MariniProducts/transformationFaceCreamMain.jpg"),
            require("../assets/images/allproducts/MariniProducts/transformationFaceCreamThumb1.jpg"),
            require("../assets/images/allproducts/MariniProducts/transformationFaceCreamThumb2.jpg")
        ],
        subHeading: "Intensive anti-aging face cream",
        overview: "Reduces signs of aging and improves skin elasticity, giving your face a youthful appearance.",
        breadcrumbImage: require("../assets/images/skin-breadcrum.jpg"),
        howToUse: { thumb: require("../assets/images/skin-breadcrum.jpg"), video: require("../assets/Video/0_Molecular_Cosmetics_1920x1080 (1).mp4") },
        benefits: ["Reduces wrinkles", "Improves elasticity", "Hydrates deeply"],
        application: ["Apply to clean face morning and night.", "Massage gently.", "Use consistently for results."]
    },

    {
        id: 10,
        name: "Age Intervention Peptide Extreme",
        category: "MariniProducts",
        logo: require("../assets/images/allproducts/logos/MSS-Logo-lockup1-color.png"),
        mainImage: require("../assets/images/allproducts/MariniProducts/ageInterventionPeptideExtremeMain.jpg"),
        images: [
            require("../assets/images/allproducts/MariniProducts/ageInterventionPeptideExtremeMain.jpg"),
            require("../assets/images/allproducts/MariniProducts/ageInterventionPeptideExtremeThumb1.jpg"),
            require("../assets/images/allproducts/MariniProducts/ageInterventionPeptideExtremeThumb2.jpg")
        ],
        subHeading: "Advanced peptide-based anti-aging serum",
        overview: "Targets wrinkles and fine lines with a potent peptide formula to rejuvenate skin.",
        breadcrumbImage: require("../assets/images/skin-breadcrum.jpg"),
        howToUse: { thumb: require("../assets/images/skin-breadcrum.jpg"), video: require("../assets/Video/0_Molecular_Cosmetics_1920x1080 (1).mp4") },
        benefits: ["Reduces wrinkles", "Rejuvenates skin", "Improves texture"],
        application: ["Apply sparingly to face.", "Massage gently until absorbed.", "Use daily morning and night."]
    },

    {
        id: 11,
        name: "Age Intervention Retinol Plus MD",
        category: "MariniProducts",
        logo: require("../assets/images/allproducts/logos/MSS-Logo-lockup1-color.png"),
        mainImage: require("../assets/images/allproducts/MariniProducts/ageInterventionRetinolPlusMdMain.jpg"),
        images: [
            require("../assets/images/allproducts/MariniProducts/ageInterventionRetinolPlusMdMain.jpg"),
            require("../assets/images/allproducts/MariniProducts/ageInterventionRetinolPlusMdThumb1.jpg"),
            require("../assets/images/allproducts/MariniProducts/ageInterventionRetinolPlusMdThumb2.jpg")
        ],
        subHeading: "Advanced Retinol formula for skin renewal",
        overview: "Reduces fine lines, improves skin tone, and promotes cellular renewal with Retinol Plus MD.",
        breadcrumbImage: require("../assets/images/skin-breadcrum.jpg"),
        howToUse: { thumb: require("../assets/images/skin-breadcrum.jpg"), video: require("../assets/Video/0_Molecular_Cosmetics_1920x1080 (1).mp4") },
        benefits: ["Reduces fine lines", "Improves tone", "Encourages renewal"],
        application: ["Apply nightly to clean skin.", "Avoid eye area.", "Follow with moisturizer."]
    },

    {
        id: 12,
        name: "Marini Luminate Face Lotion MD",
        category: "MariniProducts",
        logo: require("../assets/images/allproducts/logos/MSS-Logo-lockup1-color.png"),
        mainImage: require("../assets/images/allproducts/MariniProducts/mariniLuminateFaceLotionMdMain.jpg"),
        images: [
            require("../assets/images/allproducts/MariniProducts/mariniLuminateFaceLotionMdMain.jpg"),
            require("../assets/images/allproducts/MariniProducts/mariniLuminateFaceLotionMdThumb1.jpg"),
            require("../assets/images/allproducts/MariniProducts/mariniLuminateFaceLotionMdThumb2.jpg")
        ],
        subHeading: "Brightening and moisturizing lotion",
        overview: "Evens skin tone, brightens, and hydrates with lightweight MD formulation.",
        breadcrumbImage: require("../assets/images/skin-breadcrum.jpg"),
        howToUse: { thumb: require("../assets/images/skin-breadcrum.jpg"), video: require("../assets/Video/0_Molecular_Cosmetics_1920x1080 (1).mp4") },
        benefits: ["Brightens", "Hydrates", "Evens tone"],
        application: ["Apply to face and neck.", "Use morning and night.", "Massage gently until absorbed."]
    },

    {
        id: 13,
        name: "Age Intervention Duality MD",
        category: "MariniProducts",
        logo: require("../assets/images/allproducts/logos/MSS-Logo-lockup1-color.png"),
        mainImage: require("../assets/images/allproducts/MariniProducts/ageInterventionPeptideExtremeMain.jpg"),
        images: [
            require("../assets/images/allproducts/MariniProducts/ageInterventionPeptideExtremeMain.jpg"),
            require("../assets/images/allproducts/MariniProducts/ageInterventionPeptideExtremeThumb1.jpg"),
            require("../assets/images/allproducts/MariniProducts/ageInterventionPeptideExtremeThumb2.jpg")
        ],
        subHeading: "Dual-action anti-aging treatment",
        overview: "Combines hydration and peptide technology to target multiple signs of aging.",
        breadcrumbImage: require("../assets/images/skin-breadcrum.jpg"),
        howToUse: { thumb: require("../assets/images/skin-breadcrum.jpg"), video: require("../assets/Video/0_Molecular_Cosmetics_1920x1080 (1).mp4") },
        benefits: ["Hydrates deeply", "Reduces wrinkles", "Improves elasticity"],
        application: ["Apply to face after cleansing.", "Use morning and evening.", "Massage gently until absorbed."]
    },

    {
        id: 14,
        name: "Hyla3D Face Serum",
        category: "MariniProducts",
        logo: require("../assets/images/allproducts/logos/MSS-Logo-lockup1-color.png"),
        mainImage: require("../assets/images/allproducts/MariniProducts/hyla3DFaceSerumMain.jpg"),
        images: [
            require("../assets/images/allproducts/MariniProducts/hyla3DFaceSerumMain.jpg"),
            require("../assets/images/allproducts/MariniProducts/hyla3DFaceSerumThumb1.jpg"),
            require("../assets/images/allproducts/MariniProducts/hyla3DFaceSerumThumb2.jpg")
        ],
        subHeading: "Deep hydration serum",
        overview: "Provides intense moisture and plumping effect to revitalize skin.",
        breadcrumbImage: require("../assets/images/skin-breadcrum.jpg"),
        howToUse: { thumb: require("../assets/images/skin-breadcrum.jpg"), video: require("../assets/Video/0_Molecular_Cosmetics_1920x1080 (1).mp4") },
        benefits: ["Deep hydration", "Plumps skin", "Revitalizes"],
        application: ["Apply 2-3 drops to face.", "Massage gently.", "Use morning and night."]
    },

    {
        id: 15,
        name: "Regeneration Booster",
        category: "MariniProducts",
        logo: require("../assets/images/allproducts/logos/MSS-Logo-lockup1-color.png"),
        mainImage: require("../assets/images/allproducts/MariniProducts/regenerationBoosterMain.jpg"),
        images: [
            require("../assets/images/allproducts/MariniProducts/regenerationBoosterMain.jpg"),
            require("../assets/images/allproducts/MariniProducts/regenerationBoosterThumb1.jpg"),
            require("../assets/images/allproducts/MariniProducts/regenerationBoosterThumb2.jpg")
        ],
        subHeading: "Skin repair and rejuvenation serum",
        overview: "Boosts skin regeneration, repairs damage, and restores youthful appearance.",
        breadcrumbImage: require("../assets/images/skin-breadcrum.jpg"),
        howToUse: { thumb: require("../assets/images/skin-breadcrum.jpg"), video: require("../assets/Video/0_Molecular_Cosmetics_1920x1080 (1).mp4") },
        benefits: ["Repairs skin", "Boosts regeneration", "Restores glow"],
        application: ["Apply to face and neck.", "Use nightly.", "Massage until absorbed."]
    },

    {
        id: 16,
        name: "Clean Zyme Face Cleanser",
        category: "MariniProducts",
        logo: require("../assets/images/allproducts/logos/MSS-Logo-lockup1-color.png"),
        mainImage: require("../assets/images/allproducts/MariniProducts/cleanZymeFaceCleanserMain.jpg"),
        images: [
            require("../assets/images/allproducts/MariniProducts/cleanZymeFaceCleanserMain.jpg"),
            require("../assets/images/allproducts/MariniProducts/cleanZymeFaceCleanserThumb1.jpg"),
            require("../assets/images/allproducts/MariniProducts/cleanZymeFaceCleanserThumb2.jpg")
        ],
        subHeading: "Enzyme-based gentle cleanser",
        overview: "Removes impurities and dead skin cells with gentle enzymatic action.",
        breadcrumbImage: require("../assets/images/skin-breadcrum.jpg"),
        howToUse: { thumb: require("../assets/images/skin-breadcrum.jpg"), video: require("../assets/Video/0_Molecular_Cosmetics_1920x1080 (1).mp4") },
        benefits: ["Gentle cleansing", "Exfoliates", "Brightens skin"],
        application: ["Apply to damp skin.", "Massage gently.", "Rinse thoroughly."]
    },

    {
        id: 17,
        name: "Retinol Plus Face Mask",
        category: "MariniProducts",
        logo: require("../assets/images/allproducts/logos/MSS-Logo-lockup1-color.png"),
        mainImage: require("../assets/images/allproducts/MariniProducts/retinolPlusFaceMaskMain.jpg"),
        images: [
            require("../assets/images/allproducts/MariniProducts/retinolPlusFaceMaskMain.jpg"),
            require("../assets/images/allproducts/MariniProducts/retinolPlusFaceMaskThumb1.jpg"),
            require("../assets/images/allproducts/MariniProducts/retinolPlusFaceMaskThumb2.jpg")
        ],
        subHeading: "Retinol-infused rejuvenating mask",
        overview: "Helps reduce fine lines, smooth skin, and improve radiance.",
        breadcrumbImage: require("../assets/images/skin-breadcrum.jpg"),
        howToUse: { thumb: require("../assets/images/skin-breadcrum.jpg"), video: require("../assets/Video/0_Molecular_Cosmetics_1920x1080 (1).mp4") },
        benefits: ["Reduces fine lines", "Smooths skin", "Improves radiance"],
        application: ["Apply evenly to face.", "Leave for 10-15 minutes.", "Rinse thoroughly."]
    },

    {
        id: 18,
        name: "Skin Zyme Face Mask",
        category: "MariniProducts",
        logo: require("../assets/images/allproducts/logos/MSS-Logo-lockup1-color.png"),
        mainImage: require("../assets/images/allproducts/MariniProducts/skinZymeFaceMaskMain.jpg"),
        images: [
            require("../assets/images/allproducts/MariniProducts/skinZymeFaceMaskMain.jpg"),
            require("../assets/images/allproducts/MariniProducts/skinZymeFaceMaskThumb1.jpg"),
            require("../assets/images/allproducts/MariniProducts/skinZymeFaceMaskThumb2.jpg")
        ],
        subHeading: "Enzyme-based brightening mask",
        overview: "Gently exfoliates and brightens skin using natural enzymes.",
        breadcrumbImage: require("../assets/images/skin-breadcrum.jpg"),
        howToUse: { thumb: require("../assets/images/skin-breadcrum.jpg"), video: require("../assets/Video/0_Molecular_Cosmetics_1920x1080 (1).mp4") },
        benefits: ["Exfoliates", "Brightens", "Softens skin"],
        application: ["Apply to clean skin.", "Leave for 10 minutes.", "Rinse thoroughly."]
    },

    {
        id: 19,
        name: "Marini BioShield",
        category: "MariniProducts",
        logo: require("../assets/images/allproducts/logos/MSS-Logo-lockup1-color.png"),
        mainImage: require("../assets/images/allproducts/MariniProducts/mariniBioShieldMain.jpg"),
        images: [
            require("../assets/images/allproducts/MariniProducts/mariniBioShieldMain.jpg"),
            require("../assets/images/allproducts/MariniProducts/mariniBioShieldThumb1.jpg"),
            require("../assets/images/allproducts/MariniProducts/mariniBioShieldThumb2.jpg")
        ],
        subHeading: "Advanced skin protection formula",
        overview: "Protects skin from environmental stressors and strengthens natural barrier.",
        breadcrumbImage: require("../assets/images/skin-breadcrum.jpg"),
        howToUse: { thumb: require("../assets/images/skin-breadcrum.jpg"), video: require("../assets/Video/0_Molecular_Cosmetics_1920x1080 (1).mp4") },
        benefits: ["Protects skin", "Strengthens barrier", "Fights free radicals"],
        application: ["Apply to face and neck.", "Use daily morning.", "Massage gently."]
    },

    {
        id: 20,
        name: "Marini Multi-Acid Exfoliating Pads",
        category: "MariniProducts",
        logo: require("../assets/images/allproducts/logos/MSS-Logo-lockup1-color.png"),
        mainImage: require("../assets/images/allproducts/MariniProducts/mariniMultiAcidExfoliatingPadsMain.jpg"),
        images: [
            require("../assets/images/allproducts/MariniProducts/mariniMultiAcidExfoliatingPadsMain.jpg"),
            require("../assets/images/allproducts/MariniProducts/mariniMultiAcidExfoliatingPadsThumb1.jpg"),
            require("../assets/images/allproducts/MariniProducts/mariniMultiAcidExfoliatingPadsThumb2.jpg")
        ],
        subHeading: "Multi-acid exfoliating pads",
        overview: "Gently exfoliates and renews skin with a blend of multiple acids.",
        breadcrumbImage: require("../assets/images/skin-breadcrum.jpg"),
        howToUse: { thumb: require("../assets/images/skin-breadcrum.jpg"), video: require("../assets/Video/0_Molecular_Cosmetics_1920x1080 (1).mp4") },
        benefits: ["Exfoliates", "Smooths texture", "Improves radiance"],
        application: ["Swipe pad over clean skin.", "Use 2-3 times per week.", "Avoid eye area."]
    },

    {
        id: 21,
        name: "Marini Clear Multi-Acid Corrective Pads",
        category: "MariniProducts",
        logo: require("../assets/images/allproducts/logos/MSS-Logo-lockup1-color.png"),
        mainImage: require("../assets/images/allproducts/MariniProducts/mariniMultiAcidExfoliatingPadsMain.jpg"),
        images: [
            require("../assets/images/allproducts/MariniProducts/mariniMultiAcidExfoliatingPadsMain.jpg"),
            require("../assets/images/allproducts/MariniProducts/mariniMultiAcidExfoliatingPadsThumb1.jpg"),
            require("../assets/images/allproducts/MariniProducts/mariniMultiAcidExfoliatingPadsThumb2.jpg")
        ],
        subHeading: "Corrective pads for blemish-prone skin",
        overview: "Helps reduce blemishes and smooth skin using corrective multi-acid formula.",
        breadcrumbImage: require("../assets/images/skin-breadcrum.jpg"),
        howToUse: { thumb: require("../assets/images/skin-breadcrum.jpg"), video: require("../assets/Video/0_Molecular_Cosmetics_1920x1080 (1).mp4") },
        benefits: ["Reduces blemishes", "Exfoliates", "Smooths skin"],
        application: ["Apply to affected areas.", "Use 2-3 times per week.", "Avoid sensitive areas."]
    },

    {
        id: 22,
        name: "Marini Luminate Eye Gel",
        category: "MariniProducts",
        logo: require("../assets/images/allproducts/logos/MSS-Logo-lockup1-color.png"),
        mainImage: require("../assets/images/allproducts/MariniProducts/mariniLuminateEyeGelMain.jpg"),
        images: [
            require("../assets/images/allproducts/MariniProducts/mariniLuminateEyeGelMain.jpg"),
            require("../assets/images/allproducts/MariniProducts/mariniLuminateEyeGelThumb1.jpg"),
            require("../assets/images/allproducts/MariniProducts/mariniLuminateEyeGelThumb2.jpg")
        ],
        subHeading: "Brightening and refreshing eye gel",
        overview: "Reduces puffiness and brightens the under-eye area for a youthful look.",
        breadcrumbImage: require("../assets/images/skin-breadcrum.jpg"),
        howToUse: { thumb: require("../assets/images/skin-breadcrum.jpg"), video: require("../assets/Video/0_Molecular_Cosmetics_1920x1080 (1).mp4") },
        benefits: ["Reduces puffiness", "Brightens eyes", "Hydrates"],
        application: ["Apply a small amount under eyes.", "Pat gently.", "Use morning and night."]
    },

    {
        id: 23,
        name: "C-Esta Eye Repair Concentrate",
        category: "MariniProducts",
        logo: require("../assets/images/allproducts/logos/MSS-Logo-lockup1-color.png"),
        mainImage: require("../assets/images/allproducts/MariniProducts/cEstaEyeRepairConcentrateMain.jpg"),
        images: [
            require("../assets/images/allproducts/MariniProducts/cEstaEyeRepairConcentrateMain.jpg"),
            require("../assets/images/allproducts/MariniProducts/cEstaEyeRepairConcentrateThumb1.jpg"),
            require("../assets/images/allproducts/MariniProducts/cEstaEyeRepairConcentrateThumb1.jpg")
        ],
        subHeading: "Targeted eye repair concentrate",
        overview: "Reduces fine lines, puffiness, and dark circles with concentrated C-ESTA formula.",
        breadcrumbImage: require("../assets/images/skin-breadcrum.jpg"),
        howToUse: { thumb: require("../assets/images/skin-breadcrum.jpg"), video: require("../assets/Video/0_Molecular_Cosmetics_1920x1080 (1).mp4") },
        benefits: ["Reduces lines", "Reduces puffiness", "Brightens under-eye area"],
        application: ["Apply to under-eye area.", "Pat gently.", "Use morning and night."]
    },

    {
        id: 24,
        name: "Post-TX 1 Kit",
        category: "MariniProducts",
        logo: require("../assets/images/allproducts/logos/MSS-Logo-lockup1-color.png"),
        mainImage: require("../assets/images/allproducts/MariniProducts/postTx1KitMain.jpg"),
        images: [
            require("../assets/images/allproducts/MariniProducts/postTx1KitMain.jpg"),
            require("../assets/images/allproducts/MariniProducts/postTx1KitThumb1.jpg"),
            require("../assets/images/allproducts/MariniProducts/postTx1KitThumb2.jpg")
        ],
        subHeading: "Post-treatment care kit 1",
        overview: "Provides gentle care and hydration after dermatological treatments.",
        breadcrumbImage: require("../assets/images/skin-breadcrum.jpg"),
        howToUse: { thumb: require("../assets/images/skin-breadcrum.jpg"), video: require("../assets/Video/0_Molecular_Cosmetics_1920x1080 (1).mp4") },
        benefits: ["Soothes skin", "Hydrates", "Speeds recovery"],
        application: ["Use as instructed after treatment.", "Apply gently.", "Follow included regimen."]
    },

    {
        id: 25,
        name: "Post-TX 2 Kit",
        category: "MariniProducts",
        logo: require("../assets/images/allproducts/logos/MSS-Logo-lockup1-color.png"),
        mainImage: require("../assets/images/allproducts/MariniProducts/postTx2KitMain.jpg"),
        images: [
            require("../assets/images/allproducts/MariniProducts/postTx2KitMain.jpg"),
            require("../assets/images/allproducts/MariniProducts/postTx2KitThumb1.jpg"),
            require("../assets/images/allproducts/MariniProducts/postTx2KitThumb2.jpg")
        ],
        subHeading: "Post-treatment care kit 2",
        overview: "Enhanced kit for skin recovery and hydration after dermatological procedures.",
        breadcrumbImage: require("../assets/images/skin-breadcrum.jpg"),
        howToUse: { thumb: require("../assets/images/skin-breadcrum.jpg"), video: require("../assets/Video/0_Molecular_Cosmetics_1920x1080 (1).mp4") },
        benefits: ["Speeds recovery", "Hydrates deeply", "Soothes skin"],
        application: ["Use as directed after treatment.", "Apply gently.", "Follow included regimen."]
    }
];

export default mariniProductsData;
